import { useState, useEffect, useContext, useMemo, useRef } from "react";
import {
  Flex,
  Text,
  Box,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Heading,
  Grid,
  Button,
  Tooltip,
  Checkbox,
  useBreakpointValue,
  Center,
  IconButton,
} from "@chakra-ui/react";
import { appRequest } from "routes";
import {
  FaEdit,
  FaFileExcel,
  FaFilePdf,
  FaFileUpload,
  FaHistory,
  FaPlus,
} from "react-icons/fa";
import Pagination from "components/common/Pagination/Pagination";
import { AppContext } from "AppProvider/AppContext";
import debounce from "lodash/debounce";
import { Paginationlimit } from "components/common/functions/variable";
import ViewerModal from "App/BsesPoc/components/common/ViewerModal/ViewerModal";
import { SearchIcon } from "@chakra-ui/icons";
import MultiDropdown from "components/common/multiDropdown/MultiDropdown";
import React from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import { AiFillEye } from "react-icons/ai";
import { HiOutlineDocumentAdd, HiOutlineRefresh } from "react-icons/hi";
import SearchBox from "components/layouts/MainWindow/Navbar/SearchBox";
import {
  MdArrowUpward,
  MdArrowDownward,
  MdEmail,
  MdAssignmentInd,
} from "react-icons/md";
import TableLoader from "components/common/TableLoader/TableLoader";
import {
  addOneDayToDate,
  DDMMYYYY_FORMAT,
  formatDateTime,
} from "utils/dateUtils/dateUtils";
import { calculateDateRange, canShowDocuments } from "../../../common/function";
import exportToExcelsss, {
  transformData,
} from "../../../common/PRYViewer/component/utils/functions";
import UploadDocumentModal from "../../../common/UploadDocumentModal/UploadDocumentModal";
import CurbayMedicineCustomModal from "../../../common/PRYViewer/component/CurbayMedicineCustomModal";
import FieldsModal from "../../../common/fields/FieldsModal";
import MailModal from "../../../common/PRYViewer/component/MailModal";
import WithDrawalDocModal from "../../../common/Modals/WithDrawalDocModal";
import DeleteModal from "../../../common/Modals/DeleteModal";
import ApprovalHistoryModal from "../../../common/ApprovalHistoryModal/ApprovalHisoryModal";
import TableViewerModel from "../../../common/TableViewer/TableViewer";
import WordDocumentViewer from "../../../common/WordDocumentViewer/WordDocumentViewer";
import AddtionalDocumentModal from "../../../common/addionalDocumentModal/AddionalDocumentModal";
import FileViewerModal from "../../../common/ViewerModal/FileViewerModel";
import AddComentModal from "../../../common/AddComentModal/AddComentModal";
import CurbayViewerModel from "../../../common/ViewerModal/CurbayViewerModal/CurbayViewerModel";
import Datepicker from "../../../common/DatePicker";
import CustomDateRangePicker from "../../../common/CustomDateRangePicker/CustomDateRangePicker";
import FilesModal from "../../../common/FilesModal/FilesModal";
import DynamicSchemaModel from "./DynamicSchemaModel";
import DownloadExcelComponent from "../../../DownloadExcelComponent";
import AssignDocumentModal from "../AssignDocumentModal";

type Data = {
  _id: string;
  invoiceNo: string;
  dueDate: string;
  submittedOn: string;
  approvedOn: string;
  modifiedOn: string;
  comment?: string;
  status: string;
  file?: any;
  values?: any;
};

export default function InitiateDocument({
  name,
  type,
  activePage,
  isDisabled,
  isManual,
  isInitiator,
}: {
  name: string;
  type: string;
  activePage: string;
  isDisabled: boolean;
  isManual: boolean;
  isInitiator?: boolean;
}): JSX.Element {
  const [assignDocument, setAssignDocument] = useState({
    open: false,
    data: null,
  });

  const [openDeleteModal, setOpenDeleteModal] = useState<any>({
    data: null,
    open: false,
  });
  const [withdrawalDoc, setWithdrawalDoc] = useState<any>({
    data: null,
    open: false,
    loading: false,
  });
  const [wordType, setWordType] = useState<any>("view");
  const [openTableModel, setOpenTableModel] = useState<any>({
    type: "file",
    open: false,
    file: null,
  });
  const [openFilesModal, setOpenFilesModel] = useState<any>({
    type: "files_verification",
    open: false,
    file: null,
    data: null,
  });
  const [openSchemaModel, setOpenSchemaModel] = useState({
    open: false,
    type: "schema",
    data: null,
    initialUpload: false,
    file: null,
  });

  const { workFlowData, setActiveWorkflow, activeWorkflow, workflowProcess } =
    useContext(AppContext);
  let range: any = 6;
  if (
    workFlowData?.dateFilter?.range &&
    workFlowData?.dateFilter?.rangeActive
  ) {
    let ran = workFlowData?.dateFilter?.range?.split("-");
    if (ran[1]) {
      range = ran[1];
    }
  }

  const { startDate, endDate } = calculateDateRange(range);
  const [SelectDate, setSelectDate] = useState<any>({
    startDate: startDate,
    endDate: endDate,
  });

  const [openPryModal, setOpenPryModal] = useState({ open: false });
  const [commentModel, setCommentModel] = useState<any>({
    selectedStatus: "approved",
    open: false,
    comment: "",
    isMulti: false,
  });
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const { toastNotify } = useContext(AppContext);
  const [data, setData] = useState<Data[]>([]);
  const [search, setSearch] = useState("");
  const [selectedFile, setSelectedFile] = useState<any>({});
  const [values, setValues] = useState<any>({});
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpen, setIsOpen] = useState({
    isOpen: false,
    data: null,
    type: "isFile",
  });
  const [initialLoad, setInitialLoad] = useState(true);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const [sortColumn, setSortColumn] = useState<keyof Data | null>(null);
  const [tagType, setTagType] = useState("");
  const [documentType, setDocumentType] = useState(null);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [level, setLevel] = useState<string | null>(null);
  const [comment, setComment] = useState<string>("");
  const { accountDetails } = useContext(AppContext);
  const [transformedOptions, setTransformedOptions] = useState([]);
  const [tableObject, setTableObject] = useState<any>([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [sortDirection, setSortDirection] = useState<any>({});
  const [approvalData, setApprovalData] = useState([]);
  const [documentID, setDocumentID] = useState<any>(null);
  const [transformedData, setTransformedData] = useState<any[]>([]);
  const [fileData, setFileData] = useState<any>(null);
  const [sendMail, setSendMail] = useState<any>(false);
  const [fieldName, setFieldName] = useState<string[]>([]);
  const [finalResults, setFinalResults] = useState<any>([]);
  const fileInputRef = useRef<any>(null);
  const isBreakpoint = useBreakpointValue({ base: true, lg: false });
  const [isMailOpen, setIsMailOpen] = useState<any>({
    open: false,
    data: null,
  });

  const [searchFilters, setSearchFilters] = useState<any[]>([]);
  const [dateFrom, setFromDate] = useState(() => {
    const dateRange = workFlowData?.dateFilter?.range;
    const rangeActive = workFlowData?.dateFilter?.rangeActive;
    const today = new Date();

    if (rangeActive && dateRange) {
      const endMonth = parseInt(dateRange.split("-")[1], 10);
      today.setMonth(today.getMonth() - endMonth);
    } else {
      today.setMonth(today.getMonth() - 6);
    }
    return today;
  });

  const [dateTo, setToDate] = useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate());
    return tomorrow;
  });

  const [selectedOptions, setSelectedOptions] = useState<any>({});
  const [firstTimeCall, setFirstTimeCall] = useState(1);
  const [addtionalDocuments, setAddtionalDocuments] = useState({
    open: false,
    data: [],
  });

  const handleCloseModal = () => {
    setSelectedFile({});
    setValues({});
    setIsOpen({ isOpen: false, data: null, type: "isFile" });
    setSelectedRows([]);
    setCommentModel({
      selectedStatus: "approved",
      open: false,
      comment: "",
      isMulti: false,
    });
    setWordType("view");
  };

  const getComment = (data: any) => {
    if (data && Array.isArray(data)) {
      if (data.length) {
        let ddt: any = data.filter(
          (item: any) => item.level === accountDetails.level
        );
        if (ddt.length) {
          return ddt[ddt.length - 1].comment;
        } else {
          return data[data.length - 1].comment;
        }
      }
      return "-";
    } else {
      return "-";
    }
  };

  const handleOpenMail = (values: any) => {
    let transformed: any = [];

    if (Array.isArray(values)) {
      transformed = values[values?.length - 1]?.values;
    } else {
      if (Array.isArray(values?.values?.results)) {
        if (Array.isArray(values?.values?.results)) {
          let data = transformData(values?.values?.results);
          const groupedData = data.reduce(
            (acc: any[], { fieldName, rows, pageIndex }: any) => {
              if (!acc[pageIndex]) {
                acc[pageIndex] = { pageIndex, fields: {} };
              }
              acc[pageIndex].fields[fieldName] = rows.map((row: any) => {
                const rowData: any = {};
                for (const key in row) {
                  if (key !== "id") {
                    rowData[key] = row[key];
                  }
                }
                return rowData;
              });
              return acc;
            },
            []
          );

          transformed = groupedData;
          setTransformedData(groupedData);
        }
      }
      transformed = values;
    }

    setTransformedData(transformed);
    setIsMailOpen({ open: true });
  };

  const handleCloseMail = () => {
    setIsMailOpen({ open: false, data: null });
  };

  // useEffect (()=> {
  //   if (activeWorkflow) {
  //     handleGet()
  //   }
  // }, [activeWorkflow])

  const getDocumentType = (data: any) => {
    if (
      data.length &&
      name === "Pending Approval" &&
      accountDetails.level !== "level-1"
    ) {
      if (data.length) {
        let level: any = null;
        if (accountDetails.level === "level-2") {
          level = "level-1";
        }
        if (accountDetails.level === "level-3") {
          level = "level-2";
        }
        const dd: any = data.filter((item: any) => item.level === level);
        if (dd.length) {
          return dd[0].status;
        }
      }
      return null;
    } else {
      return null;
    }
  };

  // Commented for now
  const handleOpenModal = ({
    file,
    value,
    id,
    level,
    approvalData,
    documentId,
    tagType,
    item,
    type,
    modalType,
  }: {
    file: any;
    value: any;
    id: any;
    level: any;
    approvalData: any;
    documentId: any;
    tagType: string;
    item: any;
    type: string;
    modalType: string;
  }) => {
    if (workFlowData?.fileViewer?.approvalModalOption === "schema") {
      setValues(value);
      setSelectedId(id);
      setLevel(level);
      setComment(getComment(approvalData));
      setDocumentType(getDocumentType(approvalData));
      setSelectedRows((prevVal) => [...prevVal, item]);
      if (type !== "pdfApproval") {
        setOpenSchemaModel({
          open: true,
          data: item,
          type: "schema",
          initialUpload: false,
          file: null,
        });
      }
      setIsOpen({ isOpen: true, data: item, type: type });
      setSelectedFile(file);
      setApprovalData(approvalData);
      setDocumentID(documentId);
    } else if (file && !workFlowData?.fileViewer?.approvalModalOption.isWord) {
      setSelectedFile(file);
      setValues(value);
      setSelectedId(id);
      setLevel(level);
      setComment(getComment(approvalData));
      setApprovalData(approvalData);
      setDocumentType(getDocumentType(approvalData));
      setTagType(tagType);
      setSelectedRows((prevVal) => [...prevVal, item]);
      setIsOpen({ isOpen: true, data: item, type: type });
      setDocumentID(documentId);
      // setIsApprovalOpen({ isOpen: true, type: type });
    } else {
      if (
        !file &&
        (workFlowData?.fileViewer.approvalModalOption === "isWord" ||
          workFlowData?.fileViewer.approvalModalOption === "files_verification")
      ) {
        setSelectedFile(file);
        setValues(value);
        setSelectedId(id);
        setLevel(level);
        setComment(getComment(approvalData));
        setDocumentType(getDocumentType(approvalData));
        setTagType(tagType);
        setSelectedRows((prevVal) => [...prevVal, item]);
        if (workFlowData?.fileViewer.approvalModalOption === "isWord") {
          setIsOpen({ isOpen: true, data: item, type: type });
        }
        if (
          workFlowData?.fileViewer.approvalModalOption === "files_verification"
        ) {
          setOpenFilesModel({
            open: true,
            data: item,
            type: workFlowData?.fileViewer.approvalModalOption,
          });
        }
        setApprovalData(approvalData);
        setDocumentID(documentId);
      } else {
        toastNotify({
          title: "No file",
          message: "Something went wrong",
          type: "error",
        });
      }
    }
  };

  const downloadExcel = async (values: any, action: any) => {
    let transformed: any = [];
    let downloadValues = [];
    if (Array.isArray(values)) {
      transformed = values[values?.length - 1]?.values;
    } else {
      if (Array.isArray(values?.values?.results)) {
        let data = transformData(values?.values?.results);
        const groupedData = data.reduce(
          (acc: any[], { fieldName, rows, pageIndex }: any) => {
            if (!acc[pageIndex]) {
              acc[pageIndex] = { pageIndex, fields: {} };
            }
            acc[pageIndex].fields[fieldName] = rows.map((row: any) => {
              const rowData: any = {};
              for (const key in row) {
                if (key !== "id") {
                  rowData[key] = row[key];
                }
              }
              return rowData;
            });
            return acc;
          },
          []
        );

        transformed = groupedData;
        setTransformedData(groupedData);
      }
      downloadValues = values;
    }

    setTransformedData(transformed);

    if (workFlowData?.fileViewer?.approvalModalOption === "mdm") {
      exportToExcelsss(transformed, true);
    }
  };

  const [isUploadOpen, setIsUploadOpen] = useState<{ open: boolean; id: any }>({
    open: false,
    id: null,
  });
  const [modalType, setModalType] = useState<string>("");

  const handleOpenUploadModal = (type: string, id?: any) => {
    setOpenSchemaModel({
      open: true,
      data: null,
      type: "schema",
      initialUpload: true,
      file: null,
    });
    return;
    if (id !== null) {
      setIsUploadOpen({ open: true, id: id });
    } else {
      setIsUploadOpen({ open: true, id: null });
    }

    setModalType(type);
  };
  const handleCloseUploadModal = () => {
    setIsUploadOpen({ open: false, id: null });
  };

  const actionButton =
    tableObject?.action?.view ||
    tableObject?.action?.edit ||
    tableObject?.action?.delete;

  const handleGet = async (
    currentP?: number,
    valu?: any,
    reset?: any,
    columnSortByKey?: string,
    columnSortMode?: number
  ) => {
    try {
      let firstActiveItem: any = null;
      if (workFlowData && workFlowData?.table) {
        const activeItems = workFlowData.table.filter(
          (item: any) => item.isActive === true
        );

        firstActiveItem = activeItems.length > 0 ? activeItems[0] : {};
      }

      if (!loading) setLoading(true);
      let value = search;
      let status = type;
      let limit = firstActiveItem?.isPaginate?.isActive
        ? parseInt(firstActiveItem?.isPaginate?.paginationLimit)
        : Paginationlimit;

      if (isNaN(limit)) {
        limit = Paginationlimit;
      }
      let page = currentP ? currentP : currentPage;
      let startDate = firstTimeCall === 1 ? dateFrom : dateFrom;
      let endDate = firstTimeCall === 1 ? dateTo : addOneDayToDate(dateTo);

      let query: any = {
        value,
        limit,
        status,
        page,
        level: accountDetails.level,
        _id: accountDetails.user,
        company: accountDetails.company?._id || accountDetails.company,
        ...workflowProcess,
        isDuplicate: true,
      };

      if (
        workFlowData?.searchFilter?.key &&
        workFlowData?.searchFilter?.isActive &&
        value?.trim()
      ) {
        query = { ...query, searchField: workFlowData?.searchFilter?.key };
      }

      if (workFlowData.dateFilter?.rangeActive) {
        query = {
          ...query,
          dateFrom: startDate,
          dateTo: endDate,
        };
      }

      if (reset) {
        setFirstTimeCall(1);
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate());
        query.dateTo = tomorrow;

        const newDateFrom = calculateDateFrom();
        newDateFrom.setDate(newDateFrom.getDate());
        query.dateFrom = newDateFrom;
      }
      if (columnSortByKey && columnSortMode) {
        query = {
          ...query,
          sort: columnSortMode,
          sortByKey: columnSortByKey,
        };
      } else {
        if (workFlowData?.sortBy && workFlowData?.sortBy?.length) {
          const sorts = workFlowData.sortBy.filter(
            (item: any) => item.isActive === true
          );
          if (sorts?.length) {
            query = {
              ...query,
              sort: sorts[0].mode,
              sortByKey: sorts[0].key,
            };
          }
        }
      }

      if (
        workFlowData.dateFilter?.filterKey &&
        workFlowData.dateFilter?.filterKey?.length
      ) {
        query = { ...query, dateFilterKey: workFlowData.dateFilter?.filterKey };
      }

      if (activeWorkflow !== accountDetails?.defaultWorkflow) {
        query = { ...query, activeWorkflow: activeWorkflow };
      }

      if (type === "manual") {
        query["manual"] = true;
      }

      const searchFilters: any = [];

      for (const key in selectedOptions) {
        if (selectedOptions[key].length > 0) {
          selectedOptions[key].forEach((item: any) => {
            const filterObject: any = {};
            filterObject[key] = item.value;
            searchFilters.push(filterObject);
          });
        } else {
          const filterObject: any = {};
          filterObject[key] = selectedOptions[key].value;
          searchFilters.push(filterObject);
        }
      }

      if (!reset) {
        if (searchFilters.length) {
          query = { ...query, searchFilters: searchFilters };
        }
      }

      const response: any = await appRequest(
        "document",
        "fetchInitiatorOrCreatorDocuments",
        { ...query, ...workflowProcess }
      );

      if (response) {
        if (Array.isArray(response?.data)) {
          setData(response?.data);
          setTotalPages(response?.totalPages);
        } else {
          setData([]);
        }
      } else {
        toastNotify({
          title: `Error getting the Data`,
          message: response.message || "Something went wrong",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Error getting the Data`,
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const deleteDocuments = async () => {
    try {
      setDeleteLoading(true);
      const response: any = await appRequest("document", "delete", {
        documentId: openDeleteModal?.data?.documentId,
      });
      if (response) {
        handleGet();
        toastNotify({
          title: `Document has been deleted`,
          message: response.message || "Something went wrong",
          type: "success",
        });
        setOpenDeleteModal({ data: null, open: false });
      } else {
        toastNotify({
          title: `Failed to delete document`,
          message: response.message || "Something went wrong",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Failed to delete document`,
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
      setDeleteLoading(false);
    }
  };

  const withDrawalDocuments = async () => {
    try {
      setWithdrawalDoc({ ...withdrawalDoc, loading: true });
      const response: any = await appRequest("document", "withdrawal", {
        documentId: withdrawalDoc?.data?.documentId,
      });
      if (response) {
        handleGet();
        toastNotify({
          title: `Document has been WithDrawal`,
          message: response.message || "Something went wrong",
          type: "success",
        });
        setWithdrawalDoc({ data: null, open: false, loading: false });
      } else {
        toastNotify({
          title: `Failed to delete document`,
          message: response.message || "Something went wrong",
          type: "error",
        });
      }
    } catch (error: any) {
      setWithdrawalDoc({ ...withdrawalDoc, loading: false });
      toastNotify({
        title: `Failed to delete document`,
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
    }
  };

  //table column sorting
  const handleSort = (column: keyof Data, direction: number) => {
    setSortDirection((prevState: any) => ({
      ...prevState,
      [column]: prevState[column] === "asc" ? "desc" : "asc",
    }));

    Object.keys(sortDirection).forEach((columnKey) => {
      if (columnKey !== column) {
        setSortDirection((prevState: any) => ({
          ...prevState,
          [columnKey]: undefined,
        }));
      }
    });
    handleGet(undefined, undefined, undefined, column, direction);
  };

  const sortedData = useMemo(() => {
    if (sortColumn) {
      const sortedArray = [...data].sort((a, b) => {
        const valueA = a[sortColumn] ?? "";
        const valueB = b[sortColumn] ?? "";

        if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
        if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;

        return 0;
      });
      return sortedArray;
    }
    return data;
  }, [data, sortColumn, sortOrder]);

  useEffect(() => {
    setLoading(true);
    if (initialLoad) {
      handleGet(currentPage);
      setInitialLoad(false);
    } else {
      const debounceSearch = debounce((value) => {
        handleGet(currentPage, value);
      }, 1000);
      debounceSearch(search);
      return () => {
        debounceSearch.cancel();
      };
    }
  }, [search, currentPage, activePage, workFlowData, activeWorkflow]);

  const getFile = async (file: any) => {
    try {
      if (file?._id) {
        const response: any = await appRequest("filesystem", "get", {
          id: file._id,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);

            const fileURL = URL.createObjectURL(
              new Blob([buffer], { type: file.metadata.contentType })
            );
            return fileURL;
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    }
  };

  // Total number of pages based on the data length and items per page
  //code updation
  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected + 1);
    // handleGetInvoice(page.selected + 1);
  };

  const downloadPDF = async (file: any) => {
    const fileUrl = await getFile(file);
    if (fileUrl) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.style.display = "none";
      link.download = file.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleSelectedBoxChange = (item: any) => {
    const isSelected = selectedRows.some(
      (selectedItem) => selectedItem._id === item._id
    );
    setSelectedRows((prevSelectedRows) =>
      isSelected
        ? prevSelectedRows.filter(
          (selectedItem) => selectedItem._id !== item._id
        )
        : [...prevSelectedRows, item]
    );
  };

  const getStatus = (data: any) => {
    if (Array.isArray(data) && data?.length) {
      return data[data.length - 1].status;
    } else {
      return "-";
    }
  };

  // console.log("the open table are", openTableModel);

  function getApprovalStatus(history: any) {
    let previousFileID: any = null;
    const isRejected = history.some((item: any, index: any) => {
      const fileIDChanged = index > 0 && item.fileId !== previousFileID;
      previousFileID = item.fileId;
      return item.status === "rejected" || fileIDChanged;
    });
    return isRejected ? "rejected" : "approved";
  }
  useEffect(() => {
    if (workFlowData && workFlowData.filters) {
      let filterWorkflowFilter = workFlowData?.filters.filter(
        (item: any) => item.isActive === true
      );
      const options = filterWorkflowFilter.map((filter: any) => ({
        label: filter.label,
        placeholder: filter.placeholder,
        isMultiSelect: filter.isMultiSelect,
        key: filter.key,
        options: filter.filters
          .filter((nestedFilter: any) => nestedFilter.isActive)
          .map((nestedFilter: any) => ({
            _id: nestedFilter.key,
            value: nestedFilter.key,
            label: nestedFilter.label,
          })),
      }));
      setTransformedOptions(options);
    }
  }, [workFlowData]);

  // for table
  useEffect(() => {
    if (workFlowData && workFlowData?.table) {
      const activeItems = workFlowData.table.filter(
        (item: any) => item.isActive === true
      );

      const firstActiveItem = activeItems.length > 0 ? activeItems[0] : {};
      setTableObject(firstActiveItem);
    }
  }, [workFlowData?.table]);

  console.log(tableObject);

  // Function to generate dynamic table headers
  const generateHeaders = () => {
    return (
      <>
        <Th>Process Name</Th>
        <Th>Workflow Name</Th>
        {/* Generate dynamic headers from columnName array */}
        {tableObject?.columnName?.map((column: any, index: any) => {
          const sortingIcon =
            sortDirection[column.key] === "asc" ? (
              <MdArrowUpward />
            ) : (
              <MdArrowDownward />
            );

          if (
            [
              "Total_Tax",
              "received_doc_id",
              "Vendor_Postal_Code",
              "Rounding_Off",
              "Status",
              "inv_id",
              "MSME_Number",
              "Vendor_GSTIN_OR_Tax_Identification_Number",
              "Product_Name",
              "Buyer_PAN",
              "Currency",
              "Document_Type",
              "Eway_Bill_Number",
              "Freight",
              "Grand_Total",
              "IRN_Number",
              "start_time",
              "file_name",
              "sapDocumentNumber",
              "Buyer_GSTIN_OR_Tax_Identification_Number",
              "Digital_Signature",
              "Digital_Signature_Name",
              "Eway_Bill_Number",
            ].includes(column.key)
          ) {
            return null;
          }
          const isHovered = hoveredIndex === index;
          if (!column.isActive) return null;

          return (
            <Th
              key={index}
              cursor={column.sortActive ? "pointer" : undefined}
              onClick={() => {
                if (column.sortActive) {
                  const direction =
                    sortDirection[column.key] === "asc" ? -1 : 1;
                  handleSort(column.key, direction);
                }
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              textAlign={column.labelCenter === true ? "center" : "left"}
            >
              <Flex alignItems="center" gap={3}>
                <span
                  style={{
                    whiteSpace:
                      column.labelNoWrap === true ? "nowrap" : "unset",
                    textTransform: tableObject?.columnNameUpperCase
                      ? undefined
                      : "none",
                  }}
                >
                  {column.label?.split("_")?.join(" ")}
                </span>{" "}
                {column.sortActive && (
                  <Text
                    color="white"
                    fontSize=".7rem"
                    style={{ visibility: isHovered ? "visible" : "hidden" }}
                    wordBreak="normal"
                  >
                    {sortingIcon}
                    {/* {column.sortDirection === 'desc' && <FaSortDown />} */}
                  </Text>
                )}
              </Flex>
            </Th>
          );
        })}
        {/* Add checkbox column if any action is true */}
        {actionButton && (
          <Th>
            <Text></Text>
          </Th>
        )}
        {workFlowData?.fileViewer?.showApprHistory && (
          <Th textAlign="center">
            <Text>Approval History</Text>
          </Th>
        )}
        <Th display="none">
          <Text>Assign Doc</Text>
        </Th>
        {canShowDocuments(workFlowData, accountDetails) && <Th></Th>}
      </>
    );
  };

  const showComment = (item: any) => {
    return Array.isArray(item?.approval) ? (
      <Tooltip
        hasArrow
        label={
          item.approval.length
            ? item.approval?.map((st: any, index: number) => {
              let username = st?.user?.username?.split("@")[0];

              if (username) {
                username = username
                  .split(".")
                  .map(
                    (part: string) =>
                      part.charAt(0).toUpperCase() + part.slice(1)
                  )
                  .join(" ");
              } else {
                username = st?.designation;
              }

              let level = "";
              if (st.level === "admin") {
                level = "Admin";
              } else if (st.user?.level?.includes("level-")) {
                level = `L-${st.user?.level.split("-")[1]}`;
              }

              return (
                <Text key={index}>
                  {st.comment && `${level} - ${username} : ${st.comment}`}
                </Text>
              );
            })
            : "No Comment"
        }
      >
        <Text isTruncated w="6rem">
          {Array.isArray(item.approval)
            ? item.approval?.length
              ? item.approval[item.approval.length - 1]?.comment
              : "-"
            : ""}
        </Text>
      </Tooltip>
    ) : null;
  };

  const getTextValue = (item: any, key: any) => {
    if (!item || typeof item !== "object") {
      return "";
    }

    const value = item.originalValues?.[key] || item[key];

    if (typeof value === "string") {
      return value;
    }

    return value !== undefined ? JSON.stringify(value) : "";
  };
  // Function to generate dynamic table rows
  const generateRows = (item: any) => {
    return (
      <React.Fragment key={item._id}>
        <Td>{item?.processName}</Td>
        <Td maxW="150px">
          <Tooltip label={item?.workflowConfig?.workFlowName} hasArrow placement="top">
            <span style={{
              display: "inline-block",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%"
            }}>
              {item?.workflowConfig?.workFlowName || "--"}
            </span>
          </Tooltip>
        </Td>
        {tableObject?.columnName?.map((column: any, columnIndex: any) => {
          if (
            [
              "Total_Tax",
              "received_doc_id",
              "Vendor_Postal_Code",
              "Rounding_Off",
              "sapDocumentNumber",
              "Status",
              "inv_id",
              "MSME_Number",
              "Vendor_GSTIN_OR_Tax_Identification_Number",
              "Product_Name",
              "Buyer_PAN",
              "Currency",
              "Document_Type",
              "Eway_Bill_Number",
              "Freight",
              "Grand_Total",
              "IRN_Number",
              "start_time",
              "file_name",
              "Buyer_GSTIN_OR_Tax_Identification_Number",
              "Digital_Signature",
              "Digital_Signature_Name",
              "Eway_Bill_Number",
            ].includes(column.key)
          ) {
            return null;
          }
          if (!column.isActive) return null;
          let content = null;
          if (column.key === "comments") {
            content = <Td key={columnIndex}>{showComment(item)}</Td>;
          } else if (
            column.key === "created_At" ||
            column.key === "updated_At"
          ) {
            content = (
              <Td
                key={columnIndex}
                whiteSpace={column.rowNoWrap === true ? "nowrap" : "unset"}
              >
                {formatDateTime(item[column.key], DDMMYYYY_FORMAT, true)}
              </Td>
            );
          } else if (column.isFile) {
            content = (
              <Td
                key={columnIndex}
                color="blue.400"
                textDecoration="underline"
                fontWeight="500"
                onClick={(e: any) => {
                  e.stopPropagation();
                  if (item[column.key]?.length) {
                    if (column.fileView) {
                      setOpenTableModel({
                        type: "file",
                        open: true,
                        file: item[column.key],
                      });
                    } else {
                      toastNotify({
                        title: "Access Error",
                        message: "Sorry, there was an issue accessing the file",
                        type: "error",
                      });
                    }
                  }
                }}
              >
                {Array.isArray(item[column.key]) ? (
                  item[column.key]?.length ? (
                    <Tooltip
                      hasArrow
                      textAlign="center"
                      label={item[column.key][0]?.filename}
                    >
                      {item[column.key][0]?.filename.substring(0, 10) + "..."}
                    </Tooltip>
                  ) : (
                    "--"
                  )
                ) : (
                  JSON.stringify(item[column.key])
                )}
              </Td>
            );
          } else {
            content = (
              <Td key={columnIndex} isNumeric={column.rowType === "amount"}>
                {column.truncatedActive ? (
                  <Tooltip
                    hasArrow
                    label={
                      column.tooltipLabel
                        ? column.tooltipLabel
                        : typeof item.originalValues[column.key] === "string"
                          ? item.originalValues[column.key]
                          : JSON.stringify(item.originalValues[column.key])
                    }
                  >
                    <Text
                      isTruncated
                      w="7rem"
                      textAlign={
                        column.rowType === "number"
                          ? "center"
                          : column.rowType === "amount"
                            ? "right"
                            : "left"
                      }
                    >
                      {getTextValue(item, column.key)}
                    </Text>
                  </Tooltip>
                ) : (
                  <Text
                    textAlign={
                      column.rowType === "number"
                        ? "center"
                        : column.rowType === "amount"
                          ? "right"
                          : "left"
                    }
                    whiteSpace={column.rowNoWrap === true ? "nowrap" : "unset"}
                  >
                    {getTextValue(item, column.key)}
                  </Text>
                )}
              </Td>
            );
          }
          return content;
        })}
        {actionButton && (
          <Td>
            {/* Generate action buttons based on your logic */}
            <Flex alignItems="center" justifyContent="start">
              {tableObject?.action?.view && (
                <Tooltip label="View" hasArrow arrowSize={15}>
                  <Flex
                    alignItems="center"
                    cursor="pointer"
                    color="green.500"
                    _hover={{ color: "green.600" }}
                  >
                    <Box mr=".5rem" fontSize="1.4rem">
                      <AiFillEye />
                    </Box>
                  </Flex>
                </Tooltip>
              )}
              {tableObject?.action?.edit && (
                <Tooltip label="Edit" hasArrow arrowSize={15}>
                  <Flex
                    alignItems="center"
                    cursor="pointer"
                    mx="1rem"
                    color="green.500"
                    _hover={{ color: "green.600" }}
                  >
                    <Box mr=".5rem">
                      <FaEdit />
                    </Box>
                  </Flex>
                </Tooltip>
              )}
              {/* && name === "Pending Approval" */}
              {tableObject?.action?.delete &&
                accountDetails?.level === "admin" &&
                name === "Pending Approval" && (
                  <Tooltip label="Delete" hasArrow arrowSize={15}>
                    <Flex
                      alignItems="center"
                      cursor="pointer"
                      color="red.500"
                      _hover={{ color: "red.600" }}
                    >
                      <Box
                        mr=".5rem"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!deleteLoading)
                            setOpenDeleteModal({
                              ...openDeleteModal,
                              data: item,
                              open: true,
                            });
                        }}
                      >
                        <IconButton aria-label="delete" size="sm">
                          <RiDeleteBin5Line color="red" />
                        </IconButton>
                      </Box>
                    </Flex>
                  </Tooltip>
                )}
            </Flex>
          </Td>
        )}
        {workFlowData?.fileViewer?.showApprHistory && (
          <Td
            onClick={(e: any) => {
              e.stopPropagation();
              if (workFlowData?.fileViewer?.show) {
                let appr =
                  getApprovalStatus(item.approval) === "rejected"
                    ? "approvalHistory"
                    : "fileModal";
                handleOpenModal({
                  file: item?.file?.[0],
                  value: item.values,
                  id: item?._id,
                  level: accountDetails.level,
                  approvalData: item?.approval,
                  documentId: item?.documentId,
                  tagType: item?.tags?.extraction?.type,
                  item: item,
                  type: "pdfApproval",
                  modalType: appr,
                });
                // handleOpenModal();
              }
            }}
          >
            <Center>
              <Flex gap={3}>
                <Tooltip label="View Approval History" hasArrow arrowSize={15}>
                  <Flex
                    alignItems="center"
                    cursor="pointer"
                    color="red.500"
                    _hover={{ color: "red.600" }}
                  >
                    <Box w="30px">
                      <FaHistory />
                    </Box>
                  </Flex>
                </Tooltip>
                {accountDetails &&
                  accountDetails?.level === "level-1" &&
                  accountDetails?.role === "uploader" &&
                  checkLastRecord(item.approval) === "isReupload" ? (
                  <Tooltip label="Re-Upload Document" hasArrow arrowSize={5}>
                    <Button
                      bg="teal.300"
                      size="xs"
                      color="white"
                      _hover={{ bg: "teal.400" }}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        handleOpenUploadModal("alternative", item?._id);
                      }}
                    // leftIcon={<FaFileUpload />}
                    >
                      <FaFileUpload />
                    </Button>
                  </Tooltip>
                ) : (
                  <Box w="28px"></Box>
                )}
              </Flex>
            </Center>
          </Td>
        )}
        <Td display="none">
          <Flex gap={3}>
            <Tooltip label="Assign Doc" hasArrow arrowSize={15}>
              <Flex
                alignItems="center"
                cursor="pointer"
                color="red.500"
                _hover={{ color: "red.600" }}
              >
                <Box
                  w="30px"
                  onClick={(e: any) => {
                    e.stopPropagation();
                    setAssignDocument({ open: true, data: item });
                  }}
                >
                  <MdAssignmentInd />
                </Box>
              </Flex>
            </Tooltip>
          </Flex>
        </Td>
        {canShowDocuments(workFlowData, accountDetails) && workflowProcess.processName !== "foreign" ? (
          <Td>
            <Tooltip label="Add additional documents" hasArrow placement="left">
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedRows([item]);
                  setAddtionalDocuments({
                    open: true,
                    data: item.addtionalDocuments || [],
                  });
                }}
                textAlign="center"
              >
                <HiOutlineDocumentAdd size={18} color="#4CAF50" />
              </Box>
            </Tooltip>
          </Td>
        ) : null}
      </React.Fragment>
    );
  };

  const handleDropdownChange = (value: any, label: string) => {
    setSelectedOptions((prev: any) => ({ ...prev, [label]: value }));
    const dropdown: any = transformedOptions.find(
      (option: any) => option.label === label
    );

    if (dropdown && dropdown.options.length) {
      setSearchFilters((prevFilters: any) => {
        return [
          ...prevFilters,
          { [dropdown.key]: value?.value ? value?.value : "" },
        ];
      });
    }
  };

  const handleSearchChange = (value: string) => {
    setSearch(value);
  };

  const handleApply = () => {
    handleGet();
  };

  const handleStartDateChange = (startDate: Date) => {
    setFirstTimeCall(2);
    setFromDate(startDate);
  };

  const handleEndDateChange = (endDate: Date) => {
    setToDate(endDate);
  };

  const calculateDateFrom = () => {
    const dateRange = workFlowData?.dateFilter?.range;
    const today = new Date();

    if (dateRange) {
      const endMonth = parseInt(dateRange.split("-")[1], 10);
      today.setMonth(today.getMonth() - endMonth);
    } else {
      today.setMonth(today.getMonth() - 6);
    }

    return today;
  };

  const resetFilters = () => {
    setSearchFilters([]);
    setSelectedOptions({});
    handleGet(undefined, undefined, true);
    const newDateFrom = calculateDateFrom();
    setFromDate(newDateFrom);
    setSortDirection({});
    setSearch("");
    setToDate(() => {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate());
      return tomorrow;
    });
  };

  // const handleOpenApprovalModal = () => {
  //   setIsApprovalOpen(true);
  // };

  const handleCloseApprovalModal = () => {
    setSelectedRows([]);
    setIsOpen({ isOpen: false, data: null, type: "isFile" });
  };

  const handleOpenWordModal = () => {
    setIsOpen({ isOpen: true, data: null, type: "word" });
    setWordType("create");
  };

  function checkLastRecord(history: any) {
    if (history.length === 0) return "notUpload";

    const lastRecord = history[history.length - 1];
    const isReupload =
      lastRecord.level === "level-1" && lastRecord.status === "approved";

    return isReupload ? "isReupload" : "notUpload";
  }

  return Object.keys(tableObject).length === 0 ? (
    <Box>
      <Text textAlign="center" color="red" mt={5}>
        {" "}
        No table are selected{" "}
      </Text>
    </Box>
  ) : (
    <Box
      boxShadow="rgb(0 0 0 / 20%) 0px 0px 11px"
      bg="white"
      p={{ base: "1rem", md: "1.125rem 1.375rem" }}
      rounded={8}
    >
      <Grid
        templateColumns={"1fr auto"}
        alignItems="center"
        justifyContent="space-between"
        gap="0.5rem"
      >
        <Box>
          {tableObject?.header?.label && tableObject?.header?.isActive && (
            <Heading
              fontSize={{
                base: "1.115rem",
                lg: "1.6rem",
              }}
              color="teal.300"
              display={{ base: "none", md: "block" }}
            >
              Creator Documents
            </Heading>
          )}
          {accountDetails &&
            accountDetails?.level === "level-1" &&
            accountDetails?.role === "uploader" &&
            type === "pending" && (
              // <Tooltip label="Upload Document" hasArrow arrowSize={5}>
              <Button
                bg="teal.300"
                color="white"
                _hover={{ bg: "teal.400" }}
                onClick={() => handleOpenUploadModal("upload")}
              // leftIcon={<FaFileUpload />}
              >
                {isBreakpoint ? <FaFileUpload /> : "Upload Document"}
              </Button>
              // </Tooltip>
            )}
        </Box>
        <Flex gap="0.5rem" alignItems="center" justifyContent="end">
          <Box
            display={{ base: "none", lg: "flex" }}
            gap="0.5rem"
            justifyContent="space-between"
          >
            {tableObject?.searchActive && (
              <SearchBox
                onSearch={() => { }}
                setValue={setSearch}
                value={search}
              />
            )}
            {tableObject?.dateActive &&
              (workFlowData?.dateFilter?.rangePicker ? (
                <CustomDateRangePicker
                  onStartDateChange={handleStartDateChange}
                  onEndDateChange={handleEndDateChange}
                  dateFrom={dateFrom}
                  dateTo={dateTo}
                  months={2}
                />
              ) : (
                <>
                  <Flex>
                    <Datepicker
                      label="From"
                      date={dateFrom}
                      onDateChange={setFromDate}
                    />
                  </Flex>
                  <Flex flexDirection={"row"}>
                    <Datepicker
                      label="To"
                      date={dateTo}
                      onDateChange={setToDate}
                    />
                  </Flex>
                </>
              ))}
          </Box>
          {tableObject?.dateActive && (
            <Box display={{ base: "none", lg: "block" }}>
              <Tooltip hasArrow textAlign={"center"} label="Search">
                <Button
                  bg="teal.300"
                  color="white"
                  w={{ base: "auto", lg: "3rem" }}
                  _hover={{ bg: "teal.400" }}
                  onClick={() => handleGet()}
                >
                  <SearchIcon />
                </Button>
              </Tooltip>
            </Box>
          )}
          <Box>
            <Tooltip hasArrow textAlign={"center"} label="Reset">
              <Button
                border="2px solid"
                borderColor="teal.300"
                // w={{ base: "auto", lg: "3rem" }}
                bg="white"
                // fontSize="sm"
                color="teal.400"
                _hover={{ bg: "teal.300", color: "white" }}
                onClick={() => {
                  resetFilters();
                }}
              >
                <HiOutlineRefresh fontSize="1.2rem" />
              </Button>
            </Tooltip>
          </Box>
          {tableObject?.filterActive && (
            <>
              <Box
                display={{ base: "none", md: "block" }}
                w={{ base: "auto", lg: "3rem" }}
              >
                <MultiDropdown
                  // title="Apply Filter"
                  search={{
                    visible: workFlowData?.filters?.isActive,
                    placeholder: "select typeeeee",
                  }}
                  selectedOptions={selectedOptions}
                  onDropdownChange={handleDropdownChange}
                  dropdowns={transformedOptions}
                  onApply={handleApply}
                  searchValue={search}
                  onSearchChange={handleSearchChange}
                  resetFilters={resetFilters}
                  dateFrom={dateFrom}
                  dateTo={dateTo}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  isTable={true}
                  handleGet={handleGet}
                  tableObject={tableObject}
                />
              </Box>
              <DownloadExcelComponent
                type={type}
                isDuplicate={true}
                isException={false}
              />
              <Box
                position="fixed"
                top="15rem"
                right="1rem"
                display={{ base: "block", md: "none" }}
                w="3rem"
                zIndex={10}
              >
                <MultiDropdown
                  // title="Apply Filter"
                  search={{
                    visible: workFlowData?.filters?.isActive,
                    placeholder: "select type",
                  }}
                  selectedOptions={selectedOptions}
                  onDropdownChange={handleDropdownChange}
                  dropdowns={transformedOptions}
                  onApply={handleApply}
                  searchValue={search}
                  onSearchChange={handleSearchChange}
                  resetFilters={resetFilters}
                  dateFrom={dateFrom}
                  dateTo={dateTo}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  isTable={true}
                  handleGet={handleGet}
                  tableObject={tableObject}
                />
              </Box>
            </>
          )}
          {accountDetails &&
            accountDetails?.level === "level-1" &&
            workFlowData &&
            workFlowData?.fileViewer?.approvalModalOption === "isWord" &&
            type === "pending" && (
              <Button
                bg="teal.300"
                color="white"
                _hover={{ bg: "teal.400" }}
                onClick={handleOpenWordModal}
              >
                <Box display={{ base: "none", md: "block" }}>
                  <Text>Add Word</Text>
                </Box>
                <Box display={{ base: "block", md: "none" }}>
                  <FaPlus />
                </Box>
              </Button>
            )}
          {activePage === "Pending Approval" &&
            accountDetails.role === "approver" &&
            (workFlowData?.bulkApproveApproval ||
              workFlowData?.bulkRejectApproval) && (
              <Flex gap="0.5rem" justifyContent="end">
                {activePage === "Pending Approval" &&
                  accountDetails.role === "approver" &&
                  workFlowData?.bulkApproveApproval && (
                    <Button
                      fontSize="sm"
                      bg="green.400"
                      color="white"
                      _hover={{ bg: "green.500" }}
                      isDisabled={
                        selectedRows.length ? false : true || submitLoader
                      }
                      onClick={() =>
                        setCommentModel({
                          open: true,
                          selectedStatus: "approved",
                          comment: "",
                          isMulti: true,
                        })
                      }
                    >
                      Approve
                    </Button>
                  )}
                {activePage === "Pending Approval" &&
                  accountDetails.role === "approver" &&
                  workFlowData?.bulkRejectApproval && (
                    <Button
                      fontSize="sm"
                      isDisabled={
                        selectedRows.length ? false : true || submitLoader
                      }
                      colorScheme="red"
                      onClick={() =>
                        setCommentModel({
                          open: true,
                          selectedStatus: "rejected",
                          comment: "",
                          isMulti: true,
                        })
                      }
                    >
                      Reject
                    </Button>
                  )}
              </Flex>
            )}
        </Flex>
      </Grid>
      <Box
        position="relative"
        // width={{ lg: "calc(100vw - 13.8rem)" }}
        overflow="auto hidden"
        className="customScrollBar"
      >
        <Table
          variant={activePage === "Pending Approval" ? "simple" : "striped"}
          mt="1rem"
        >
          <Thead>
            <Tr>
              {activePage === "Pending Approval" &&
                (workFlowData?.bulkApproveApproval ||
                  workFlowData?.bulkRejectApproval) &&
                accountDetails.role === "approver" && (
                  <Th w={10}>
                    <Checkbox
                      colorScheme="teal"
                      isChecked={data.length === selectedRows.length}
                      isIndeterminate={
                        selectedRows.length > 0 &&
                        data.length !== selectedRows.length
                      }
                      onChange={(e: any) => {
                        if (e.target.checked) {
                          setSelectedRows(data);
                        } else {
                          setSelectedRows([]);
                        }
                      }}

                    // mr={2}
                    />
                  </Th>
                )}
              {generateHeaders()}
              {workFlowData?.withdrawalApproval?.includes(
                name?.toLowerCase()
              ) &&
                workFlowData.withdrawalLevel.includes(accountDetails.level) && (
                  <Th>Withdrawal Doc</Th>
                )}
              {((tableObject.action.downloadPDF &&
                accountDetails?.userPermission?.includes("download")) ||
                (tableObject.action.downloadExcel &&
                  accountDetails?.userPermission?.includes("download")) ||
                accountDetails?.userPermission?.includes("mail")) &&
                name === "Approved" && <Th></Th>}
            </Tr>
          </Thead>
          <Tbody>
            <TableLoader
              loader={loading}
              show={data.length}
              columns={
                actionButton && workFlowData?.fileViewer?.showApprHistory
                  ? tableObject?.columnName?.length + 2
                  : actionButton
                    ? tableObject?.columnName?.length + 1
                    : workFlowData?.fileViewer?.showApprHistory
                      ? tableObject?.columnName?.length + 1
                      : tableObject?.columnName?.length
              }
            >
              {sortedData.map((item: any, index) => (
                <React.Fragment key={index}>
                  <Tr
                    fontSize="sm"
                    onClick={(e: any) => {
                      if (workFlowData?.fileViewer?.show) {
                        let appr =
                          getApprovalStatus(item.approval) === "rejected"
                            ? "approvalHistory"
                            : "fileModal";
                        handleOpenModal({
                          file: item?.file?.[0],
                          value: item.values,
                          id: item?._id,
                          level: accountDetails.level,
                          approvalData: item?.approval,
                          documentId: item?.documentId,
                          tagType: item?.tags?.extraction?.type,
                          item: item,
                          type:
                            workFlowData?.fileViewer?.approvalModalOption ===
                              "isFile"
                              ? "file"
                              : workFlowData?.fileViewer
                                ?.approvalModalOption === "isTable"
                                ? "table"
                                : workFlowData?.fileViewer
                                  ?.approvalModalOption === "isCurebay"
                                  ? "curebay"
                                  : workFlowData?.fileViewer
                                    ?.approvalModalOption === "schema"
                                    ? "schema"
                                    : workFlowData?.fileViewer
                                      ?.approvalModalOption === "pdfApproval"
                                      ? "pdfApproval"
                                      : workFlowData?.fileViewer
                                        ?.approvalModalOption === "mdm"
                                        ? "mdm"
                                        : workFlowData?.fileViewer
                                          ?.approvalModalOption === "fields"
                                          ? "fields"
                                          : "word",
                          modalType: appr,
                        });
                        // handleOpenModal();
                      }
                    }}
                    cursor="pointer"
                    key={index}
                    bg={
                      activePage === "Pending Approval"
                        ? getStatus(item.approval) === "rejected"
                          ? "red.100"
                          : getStatus(item.approval) === "approved"
                            ? "green.100"
                            : undefined
                        : undefined
                    }
                  >
                    {activePage === "Pending Approval" &&
                      (workFlowData?.bulkApproveApproval ||
                        workFlowData?.bulkRejectApproval) &&
                      accountDetails.role === "approver" && (
                        <Td onClick={(e: any) => e.stopPropagation()}>
                          <Flex alignItems="center">
                            <Checkbox
                              // p={0}
                              // m={0}
                              variant="outline"
                              borderColor="teal"
                              colorScheme="teal"
                              isChecked={selectedRows.some(
                                (it: any) => it._id === item._id
                              )}
                              onMouseDown={(e: any) => {
                                e.stopPropagation();
                                e.preventDefault();
                              }}
                              onChange={(e: any) => {
                                handleSelectedBoxChange(item);
                              }}
                            />
                          </Flex>
                        </Td>
                      )}
                    {generateRows(item)}
                    {workFlowData?.withdrawalApproval?.includes(
                      name?.toLowerCase()
                    ) &&
                      workFlowData.withdrawalLevel.includes(
                        accountDetails.level
                      ) && (
                        <Td
                          onClick={(e: any) => {
                            e.stopPropagation();
                            setWithdrawalDoc({
                              open: true,
                              data: item,
                            });
                          }}
                        >
                          Withdrawal Doc
                        </Td>
                      )}
                    {((tableObject.action.downloadPDF &&
                      accountDetails?.userPermission?.includes("download")) ||
                      (tableObject.action.downloadExcel &&
                        accountDetails?.userPermission?.includes("download")) ||
                      accountDetails?.userPermission?.includes("mail")) &&
                      name === "Approved" && (
                        <Td>
                          <Flex alignItems="center" gap={2}>
                            {tableObject.action.downloadPDF &&
                              accountDetails?.userPermission?.includes(
                                "download"
                              ) && (
                                <Tooltip label="Download PDF" hasArrow>
                                  <Button
                                    size="xs"
                                    color="white"
                                    bg="red.400"
                                    _hover={{ bg: "red.500" }}
                                    onClick={(e: any) => {
                                      e.stopPropagation();
                                      if (item?.file?.length) {
                                        downloadPDF(item?.file?.[0]);
                                      } else {
                                        toastNotify({
                                          title: "No file",
                                          message: "Something went wrong",
                                          type: "error",
                                        });
                                      }
                                    }}
                                  >
                                    <Text>
                                      <FaFilePdf />
                                    </Text>
                                  </Button>
                                </Tooltip>
                              )}
                            {tableObject.action.downloadExcel &&
                              accountDetails?.userPermission?.includes(
                                "download"
                              ) &&
                              name === "Approved" && (
                                <Tooltip label="Download Excel" hasArrow>
                                  <Button
                                    size="xs"
                                    color="white"
                                    bg="green.500"
                                    _hover={{ bg: "green.600" }}
                                    onClick={(e: any) => {
                                      e.stopPropagation();
                                      if (
                                        Array.isArray(item?.values) &&
                                        item?.values?.length
                                      ) {
                                        downloadExcel(item?.values, "download");
                                      } else if (
                                        !Array.isArray(item?.values) &&
                                        item?.values?.values
                                      ) {
                                        downloadExcel(item?.values, "download");
                                      } else
                                        toastNotify({
                                          title: "No Data Found",
                                          message: "Something went wrong",
                                          type: "error",
                                        });
                                    }}
                                  >
                                    <Text>
                                      <FaFileExcel />
                                    </Text>
                                  </Button>
                                </Tooltip>
                              )}
                            {accountDetails?.userPermission?.includes("mail") &&
                              name === "Approved" && (
                                <Tooltip
                                  label="Send mail with attachment"
                                  hasArrow
                                >
                                  <Button
                                    size="xs"
                                    color="white"
                                    bg="green.500"
                                    _hover={{ bg: "green.600" }}
                                    onClick={(e: any) => {
                                      e.stopPropagation();
                                      if (
                                        Array.isArray(item?.values) &&
                                        item?.values?.length
                                      ) {
                                        handleOpenMail(item?.values);
                                      } else if (
                                        !Array.isArray(item?.values) &&
                                        item?.values?.values
                                      ) {
                                        handleOpenMail(item?.values);
                                      } else
                                        toastNotify({
                                          title: "No Data Found",
                                          message: "Something went wrong",
                                          type: "error",
                                        });
                                    }}
                                  >
                                    <Text>
                                      <MdEmail />
                                    </Text>
                                  </Button>
                                </Tooltip>
                              )}
                          </Flex>
                        </Td>
                      )}
                  </Tr>
                </React.Fragment>
              ))}
            </TableLoader>
          </Tbody>
        </Table>
      </Box>

      {isOpen.isOpen && isOpen.type === "file" && (
        <ViewerModal
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          // isEditable={workFlowData?.fileViewer?.editable}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
        />
      )}

      {isOpen.isOpen && isOpen.type === "curebay" && (
        <CurbayViewerModel
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          // isEditable={workFlowData?.fileViewer?.editable}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
        />
      )}

      {tableObject?.isPaginate?.isActive && (
        <Pagination
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          currentPage={currentPage}
        />
      )}
      {commentModel.isMulti === true && (
        <AddComentModal
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          view={false}
          handleCloseModal={handleCloseModal}
          editedValues={{}}
          isMulti={true}
        />
      )}
      {/* <TableViewer
        isOpen={isTableOpen}
        onClose={() => handleCloseTable()}
        handleGet={handleGet}
      /> */}
      {openTableModel.open && openTableModel.file && (
        <FileViewerModal
          isOpen={openTableModel.open}
          onClose={() => {
            setOpenTableModel({ open: false, type: "file", file: null });
          }}
          viewerWidth="70vw"
          file={
            Array.isArray(openTableModel.file)
              ? openTableModel.file.length > 0
                ? openTableModel.file[0]
                : null
              : openTableModel.file
          }
        />
      )}

      {addtionalDocuments.open && (
        <AddtionalDocumentModal
          handleGet={handleGet}
          selectedRows={selectedRows}
          isOpen={addtionalDocuments.open}
          onClose={() => {
            setSelectedRows([]);
            setAddtionalDocuments({ data: [], open: false });
          }}
        />
      )}

      {isOpen.isOpen && isOpen.type === "word" && (
        <WordDocumentViewer
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          // isEditable={workFlowData?.fileViewer?.editable}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          type={wordType}
          statusType={type}
        />
      )}

      {isOpen.isOpen && isOpen.type === "table" && (
        <TableViewerModel
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          // isEditable={workFlowData?.fileViewer?.editable}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          tableObject={tableObject}
        />
      )}

      {isOpen.isOpen && isOpen.type === "pdfApproval" && (
        <ApprovalHistoryModal
          isOpen={isOpen.isOpen}
          onClose={handleCloseApprovalModal}
          name={name}
          approvalHistory={approvalData}
          file={selectedFile}
          id={selectedId}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          handleGet={handleGet}
          docID={documentID}
        />
      )}

      {openFilesModal.open === true &&
        openFilesModal.data &&
        openFilesModal.type === "files_verification" && (
          <FilesModal
            isDisabled={isDisabled}
            commentData={comment}
            tagType={tagType}
            documentType={documentType}
            name={name}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            commentModel={commentModel}
            setCommentModel={setCommentModel}
            file={selectedFile}
            docID={documentID}
            values={values}
            open={openFilesModal.open}
            data={openFilesModal.data}
            getData={handleGet}
            close={() => {
              setOpenFilesModel({
                open: false,
                data: null,
                type: "files_verification",
              });
            }}
          />
        )}
      <UploadDocumentModal
        isOpen={isUploadOpen.open}
        onClose={handleCloseUploadModal}
        type={modalType}
        handleGet={handleGet}
        id={isUploadOpen.id}
      />

      {isOpen.isOpen && isOpen.type === "mdm" && (
        <CurbayMedicineCustomModal
          handleGet={handleGet}
          open={isOpen.isOpen}
          close={() => {
            setSelectedRows([]);
            setIsOpen({ isOpen: false, type: "mdm", data: null });
          }}
          getData={handleGet}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          file={selectedFile}
          docID={documentID}
          values={values}
        />
      )}

      {isOpen.isOpen && isOpen.type === "fields" && (
        <FieldsModal
          handleGet={handleGet}
          open={isOpen.isOpen}
          close={() => {
            setSelectedRows([]);
            setIsOpen({ isOpen: false, type: "fields", data: null });
          }}
          getData={handleGet}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          file={selectedFile}
          docID={documentID}
          values={values}
        />
      )}

      <MailModal
        fileData={fileData}
        isOpen={isMailOpen.open}
        onClose={handleCloseMail}
        fieldName={fieldName}
        setFieldName={setFieldName}
        transformedData={exportToExcelsss(transformedData)}
        values={isMailOpen.data}
        setFileData={setFileData}
        sendMail={["mail"]}
        setFinalResults={setFinalResults}
      // data={data}
      />

      {openSchemaModel.open && openSchemaModel.type === "schema" && (
        <DynamicSchemaModel
          openSchemaModal={openSchemaModel}
          isOpen={openSchemaModel.open}
          data={openSchemaModel.data}
          file={selectedFile}
          onClose={() => {
            setOpenSchemaModel({
              open: false,
              data: null,
              type: "schema",
              initialUpload: false,
              file: null,
            });
            setSelectedRows([]);
          }}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          name={name}
        />
      )}

      <WithDrawalDocModal
        title={`Document : ${withdrawalDoc?.data?.documentId}`}
        bodyText="This action cannot be undone"
        subTitleText="Please Confirm?"
        onConfirm={() => withDrawalDocuments()}
        isOpen={withdrawalDoc.open}
        onClose={() =>
          setWithdrawalDoc({ data: null, open: false, loading: false })
        }
        loading={withdrawalDoc?.loading}
      />

      <DeleteModal
        title={`Document : ${openDeleteModal?.data?.documentId}`}
        bodyText="This action cannot be undone. Deleting this user will remove all associated permissions."
        subTitleText="Please Confirm?"
        onConfirm={() => deleteDocuments()}
        isOpen={openDeleteModal.open}
        onClose={() => setOpenDeleteModal({ data: null, open: false })}
        loading={deleteLoading}
      />

      <AssignDocumentModal
        isOpen={assignDocument.open}
        data={assignDocument?.data}
        close={() => setAssignDocument({ open: false, data: null })}
        getAllData={handleGet}
        isDuplicate={true}
        isPending={true}
      />
    </Box>
  );
}